// Async Thunk for fetching banners
import axios from "axios";
import { createAsyncThunk } from "@reduxjs/toolkit";
const BASE_URL = process.env.REACT_APP_BASE_URL;



export const fetchCategories = createAsyncThunk(
  "categories/fetchCategories",
  async (lang, { rejectWithValue }) => {
    try {
      const response = await axios.get(`${BASE_URL}/categories`, {
        headers: {
          'Accept-Language': lang || 'en'
        }
      });
      return response.data;
    } catch (error) {
      const message = error.response?.data?.message || "Failed to fetch categories";
      return rejectWithValue({ message });
    }
  }
);
export const fetchSubcategories = createAsyncThunk(
  "categories/fetchSubcategories",
  async ({ categoryId, lang, page = 1 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/categories/${categoryId}/subcategories`,
        {
          headers: {
            "Accept-Language": lang || "en",
          },
          params: {
            page,
            per_page: 10, // عدد العناصر لكل صفحة
          },
        }
      );
      // //console.log('API Response for subcategories:', response.data);
      // //console.log('Response data type:', typeof response.data.data);
      // //console.log('Response data is array:', Array.isArray(response.data.data));
      // //console.log('Response data length:', response.data.data?.length);
      
      const result = {
        categoryId,
        data: response.data.data,
        pagination: response.data.pagination,
      };
      
      // //console.log('Returning from action:', result);
      return result;
    } catch (error) {
      const message =
        error.response?.data?.message || "Failed to fetch subcategories";
      return rejectWithValue({ message });
    }
  }
);

export const fetchSubcategoriesProducts = createAsyncThunk(
  "categories/fetchSubcategoriesProducts",
  async ({ sub, lang, page = 1 }, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${BASE_URL}/products/subcategory/${sub}`,
        {
          headers: {
            'Accept-Language': lang || 'en'
          },
          params: {
            page,
            per_page: 12 
          }
        }
      );
      
      return { 
        id : sub,
        data: response.data.data,
        pagination: response.data.pagination
      };
    } catch (error) {
      const message = error.response?.data?.message || 
                     "Failed to fetch products";
      return rejectWithValue({ message });
    }
  }
);